import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchPerguntasConselhoMunicipal, fetchEnquetesPergunta, fetchEnquetesRespostas, postEnquetesVotar,
} from '../../api/endpoints';
import { resetarModais, selectModal, fecharModalEnquete } from '../../app/slices/modalSlice';
import { selectLogin } from '../../app/slices/loginSlice';
import ListaEnquete from '../../components/ListaEnquete/ListaEnquete';
import Botao from '../../components/Botao/Botao';
import AppHeader from '../../components/AppHeader/AppHeader';
import {
  Alerta, Centro, ContainerJanela, Divisor, FormFooter, LabelEnquete, Linha,
  AppBody, AppFragment, Container, Interno, Titulo,
} from '../../styles/base';
import Carregar from '../../components/Carregar/Carregar';
import { LinhaForm } from '../../components/FormControl/FormControlEstilo';
import ModalContato from '../../components/ModalContato/ModalContato';
import ModalEnquete from '../../components/ModalEnquete/ModalEnquete';
import ModalLogin from '../../components/ModalLogin/ModalLogin';

const IniciarEnqueteConselho = () => {
  const dadosModal = useSelector(selectModal);
  const [perguntas, setPerguntas] = useState([]);
  const [carregando, setCarregando] = useState(false);
  const [listaRespostas, setListaRespostas] = useState(null);
  const [aberto, setAberto] = useState(false);
  const dispatch = useDispatch();
  const dadosLogin = useSelector(selectLogin);

  const respostasDaDeterminadaPergunta = (pergunta) => {
    const respostas = listaRespostas && listaRespostas.filter((resposta) => resposta.IdEnquete === pergunta.Id);
    return respostas;
  };

  const ExibiLoader = () => {
    setCarregando(true);
    setTimeout(() => {
      setCarregando(false);
    }, 300);
    Promise.all([
      fetchPerguntasConselhoMunicipal(),
      fetchEnquetesRespostas(),
    ]).then(([dadosEnquetesPergunta, dadosEnquetesRespostas]) => {
      setPerguntas(dadosEnquetesPergunta);
      setListaRespostas(dadosEnquetesRespostas);
    });
    setAberto(false);
    return true;
  };

  const perguntas2 = perguntas.length > 0 && perguntas.filter((pergunta) => respostasDaDeterminadaPergunta(pergunta) && respostasDaDeterminadaPergunta(pergunta).length > 0);

  useEffect(() => {
    Promise.all([
      fetchPerguntasConselhoMunicipal(),
      fetchEnquetesRespostas(),
    ]).then(([dadosEnquetesPergunta, dadosEnquetesRespostas]) => {
      setPerguntas(dadosEnquetesPergunta);
      setListaRespostas(dadosEnquetesRespostas);
    });
  }, [dadosLogin]);

  window.onload = () => {
    dispatch(resetarModais());
  };

  return (
    <AppFragment onKeyDown={(e) => {
      if (e.key === 'Escape') {
        dispatch(resetarModais());
      }
    }}
    >
      {dadosModal.modalLogin === 'aberto' && (<ModalLogin />)}
      {dadosModal.modalEnquete === 'aberto' && (<ModalEnquete />)}
      {dadosModal.modalContato === 'aberto' && (<ModalContato />)}
      <AppHeader />
      <AppBody desfoque={dadosModal.desfoque}>
        <Container>
          <Titulo>Avaliação do Conselho de Usuários</Titulo>

          <Divisor />

          <b style={{ fontSize: '20px' }}>Enquetes: </b>

          <Divisor />
          <Divisor />

          {carregando && (
            <Carregar />
          )}

          {(perguntas2.length > 0) ? (
            perguntas2.map((pergunta) => (
              (<ListaEnquete id={pergunta.Id} campo={pergunta.Campo} funcaoExibiLoader={ExibiLoader} />)
            ))) : (<p>Não há enquetes disponíveis.</p>)}

        </Container>
      </AppBody>
    </AppFragment>
  );
};

export default IniciarEnqueteConselho;
